import Stack from "@mui/material/Stack/Stack";
import React from "react";
import Paper from "@mui/material/Paper";
import { Button, Fab, Input, TextField, Typography } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import { LoadPositionList } from "../../../../../../domain/usecases/load-position-list";
import { PositionNotFountError } from "../../../../../../domain/errors/position-not-found-error";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { Position } from "../../../../../../domain/models/position-model";
import { StoreItem } from "../../../../../../domain/usecases/store-item";
import { useSelector } from "react-redux";
import { StoreState } from "../../store";
import { ReceiptCheckItem } from "../../../../../../domain/models/receipt-check";
import { CustomDialog } from "../../../../../components/Dialog";
import { RootState } from "../../../../../store";

type Props = {
  loadPositionList: LoadPositionList;
  storeItem: StoreItem;
};

export const StorePositionCollector: React.FC<Props> = ({
  loadPositionList,
  storeItem,
}) => {
  const getCurrentWarehouse = useSelector<
    RootState,
    () => { id: number; name: string }
  >((state) => state.getCurrentWarehouse);
  const navigate = useNavigate();
  const [code, setCode] = React.useState<string>("");
  const [amount, setAmount] = React.useState<string>("");
  const [position, setPosition] = React.useState<Position | null>(null);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const item = useSelector<StoreState, ReceiptCheckItem | null>(
    (state) => state.currentItem
  );

  const onBlur = async () => {
    if (!code) return;
    try {
      const warehouseString = localStorage.getItem("currentWarehouse");
      const warehouse = warehouseString
        ? (JSON.parse(warehouseString) as {
            id: number;
            name: string;
          } | null)
        : undefined;
      const list = await loadPositionList.load({
        warehouseId: warehouse!.id,
        filterOptions: { code },
      });
      if (!list || list.length === 0) {
        return alert("Posição não encontada");
      }
      setPosition(list[0]);
    } catch (error: any) {
      if (error instanceof PositionNotFountError) {
        alert(error.message);
      } else {
        alert("Um erro inesperado ocorreu. Tente novamente.");
      }
    }
  };

  const handleClick = async () => {
    if (!position) {
      return alert("Insira o código da posição antes de continuar.");
    }

    if (!item) {
      alert("Erro. Reinicie o processo.");
      navigate("/mobile/store");
    }

    if (!amount) return alert("Insira a quantidade antes de continuar.");

    if (
      Number((Number(amount) * (item?.packageAmount || 1)).toFixed(4)) >
      Number((item!.countedAmount - item!.storedAmount).toFixed(4))
    ) {
      return alert("Quantidade inválida");
    }
    handleConfirm();
  };

  const handleConfirm = async () => {
    try {
      const res = await storeItem.store({
        positionId: position!.id!,
        amount: Number(
          (parseFloat(amount) * (item?.packageAmount || 1)).toFixed(4)
        ),
        itemId: item?.id!,
      });
      if (!res)
        return alert("Não foi possível guardar o item. Tente novamente.");
      alert("Produto guardado com sucesso!");
      navigate("/mobile/store");
    } catch (error) {
      alert("Um erro inesperado aconteceu. Tente novamente mais tarde");
    }
  };

  return (
    <>
      <CustomDialog
        title="Confirmar Operação?"
        isOpen={isOpen}
        yesText="Confirmar"
        onYes={handleConfirm}
        onNo={() => {
          setIsOpen(false);
        }}
        handleClose={() => {
          setIsOpen(false);
        }}
      />
      <DrawerAppBar
        onBack={() => {
          navigate("/mobile/store/collector");
        }}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <Paper>
          <Stack spacing={4} sx={{ padding: "20px" }}>
            {position && (
              <Typography fontWeight="bold" fontSize={"26px"}>
                {" "}
                {`${position?.street}.${position?.building}.${position?.level}.${position?.apartment}`}
              </Typography>
            )}
            <Stack direction="row">
              <TextField
                id="outlined-basic"
                label="Código da Posição"
                variant="outlined"
                sx={{
                  mx: "5px",
                }}
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
                onBlur={onBlur}
              />
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  mx: "5px",
                }}
              >
                <QrCodeIcon />
              </Button>
            </Stack>

            <Stack>
              <Typography sx={{ mx: "5px" }}>Quantidade</Typography>
              <Stack
                direction="row"
                sx={{
                  my: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Fab
                  color="primary"
                  aria-label="add"
                  size="small"
                  onClick={() => {
                    if (amount && amount !== "0") {
                      const newValue = parseFloat(amount) - 1;
                      setAmount(newValue.toString());
                    }
                  }}
                >
                  <RemoveIcon />
                </Fab>

                <Input
                  sx={{ width: "70px", mx: "30px" }}
                  type="text"
                  value={amount}
                  onChange={(event) => {
                    const inputValue = event.target.value;
                    if (/^[0-9.]+$/.test(inputValue) || inputValue === "") {
                      setAmount(inputValue);
                    }
                  }}
                />
                <Fab
                  color="primary"
                  aria-label="add"
                  size="small"
                  onClick={() => {
                    if (amount) {
                      const newValue = parseFloat(amount) + 1;
                      setAmount(newValue.toString());
                    } else {
                      setAmount("1");
                    }
                  }}
                >
                  <AddIcon />
                </Fab>
              </Stack>
            </Stack>
          </Stack>
        </Paper>

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={handleClick}
        >
          Guardar
        </Button>
      </Stack>
    </>
  );
};
